// extracted by mini-css-extract-plugin
export var wrapper = "search-module--wrapper--yD9gI";
export var loadBtn = "search-module--loadBtn--vQfaN";
export var searchInput = "search-module--searchInput--qvkUb";